import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import 'prop-types';
import * as React from 'react';
import { useDebouncedCallback } from 'use-debounce';

function useIsTruncated(ref) {
  var debounceDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      truncated = _React$useState2[0],
      setTruncated = _React$useState2[1];

  var isTruncated = React.useCallback(function () {
    var node = ref.current;
    if (!node) return;
    setTruncated(node.scrollWidth > node.clientWidth);
  }, [ref]);
  var debouncedIsTruncated = useDebouncedCallback(isTruncated, debounceDelay);
  React.useEffect(function () {
    isTruncated();
    window.addEventListener("resize", debouncedIsTruncated);
    return function () {
      return window.removeEventListener("resize", debouncedIsTruncated);
    };
  }, [debouncedIsTruncated, isTruncated]);
  return truncated;
}

export { useIsTruncated };
